export interface FileBase {
  id: string;
  name: string;
  description: string;
  contentType: string;
  sizeInBytes: number;
  sizeInMegaBytes: number;
}

export interface FilesFilter {
  companyId: number;
  entityType?: EntityType | null;
  entityId?: string | null;
}

export enum EntityType {
  ACCOUNTING_DOCUMENT = 'AccountingDocument',
  OTHER = 'Other',
  USER_TASK = 'UserTask',
}

export enum AttachmentType {
  ACCOUNTING_DOCUMENT_PDF = 'AccountingDocumentPdf',
  OTHER = 'Other',
}
